import { useMemo } from "react"

import { FEATURE_FLAGS, useFeatureFlagValue } from "@/feature-flags"

import type { NavigationFeatureFlag } from "../types"

export function useNavigationFeatureFlagStatus(): Partial<
  Record<NavigationFeatureFlag, boolean>
> {
  const isBenchmarksEnabled = useFeatureFlagValue(FEATURE_FLAGS.BENCHMARKS)
  const isHumanReviewRoleModesEnabled = useFeatureFlagValue(
    FEATURE_FLAGS.HUMAN_REVIEW_ROLE_MODES,
  )

  return useMemo(
    () => ({
      [FEATURE_FLAGS.BENCHMARKS]: !!isBenchmarksEnabled,
      [FEATURE_FLAGS.HUMAN_REVIEW_ROLE_MODES]: !!isHumanReviewRoleModesEnabled,
    }),
    [isBenchmarksEnabled, isHumanReviewRoleModesEnabled],
  )
}
